import api from './api';

export const trackingService = {
  async getApplications() {
    const response = await api.get('/track/applications');
    return response.data;
  },

  async submitApplication(applicationId) {
    const response = await api.post(`/track/submit/${applicationId}`);
    return response.data;
  },

  async getApplicationStatus(applicationId) {
    const response = await api.get(`/track/status/${applicationId}`);
    return response.data;
  }
};